import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1a1a26',
            color: '#e8e8f0',
            border: '1px solid #2a2a3a',
            fontSize: '13px',
          },
          success: { iconTheme: { primary: '#00e5a0', secondary: '#1a1a26' } },
          error: { iconTheme: { primary: '#ff6b6b', secondary: '#1a1a26' } },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
)
